import { render, staticRenderFns } from "./PickupAddress.vue?vue&type=template&id=19eb4cbc&scoped=true&"
import script from "./PickupAddress.vue?vue&type=script&lang=ts&"
export * from "./PickupAddress.vue?vue&type=script&lang=ts&"
import style0 from "./PickupAddress.vue?vue&type=style&index=0&id=19eb4cbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19eb4cbc",
  null
  
)

export default component.exports